import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';

import Button from '../../shared/button.component';
import Spinner from '../../shared/spinner.component';
import StatusBadge from '../../shared/statusBadge.component';
import FormControl from '../../shared/forms/formControl.component';

class GlUIConnectionForm extends PureComponent {
  static propTypes = {
    calculateProvisionsForGlUIConnection: PropTypes.func.isRequired,
    onCheckboxChange: PropTypes.func.isRequired,
    onLedgersChange: PropTypes.func.isRequired,
    refreshStatus: PropTypes.func.isRequired,

    calculateProvisions: PropTypes.bool.isRequired,
    connection: PropTypes.shape({
      connName: PropTypes.string.isRequired,
    }),
    connStatusName: PropTypes.string,
    isUploading: PropTypes.bool.isRequired,
    lastUpdateTime: PropTypes.string,
    ledgers: PropTypes.string.isRequired,
    loadTrialBalances: PropTypes.bool.isRequired,
    updatedOn: PropTypes.string,
    isRefreshingStatus: PropTypes.bool,
    canLoadTrialBalanceAndCalculate: PropTypes.bool.isRequired,
  };

  render() {
    const {
      calculateProvisions,
      calculateProvisionsForGlUIConnection,
      connection,
      connStatusName,
      isUploading,
      lastUpdateTime,
      ledgers,
      loadTrialBalances,
      onCheckboxChange,
      onLedgersChange,
      refreshStatus,
      updatedOn,
      isRefreshingStatus,
      canLoadTrialBalanceAndCalculate,
    } = this.props;

    return (
      <div>
        <div className="row">
          <div className="col-sm-8">
            {canLoadTrialBalanceAndCalculate ? (
              <>
                <div className="form-group batch-provisions-form">
                  <input
                    className="batch-provision-checkbox"
                    disabled
                    type="checkbox"
                    name="loadTrialBalances"
                    onChange={onCheckboxChange}
                    checked={loadTrialBalances}
                  />
                  <label htmlFor="calculateProvisions">
                    Load Trial Balances
                  </label>
                  <input
                    className="batch-provision-checkbox"
                    disabled
                    type="checkbox"
                    name="calculateProvisions"
                    onChange={onCheckboxChange}
                    checked={calculateProvisions}
                  />
                  <label htmlFor="calculateProvisions">
                    Calculate Provisions
                  </label>
                </div>
                <div className="batch-provison-ledgers-input">
                  <FormControl
                    onChange={onLedgersChange}
                    name="ledgers"
                    label="Ledgers"
                    value={ledgers}
                  >
                    <input
                      type="text"
                      placeholder="Enter Ledger IDs for company codes to calculate (separate with comma)"
                    />
                  </FormControl>
                </div>
              </>
            ) : (
              <div className="form-group batch-provisions-form" />
            )}
          </div>
          <div className="col-sm-4">
            {
              isRefreshingStatus
                ? (
                  <div className="status-loading-placeholder">
                    <Spinner className="d-flex spinner-no-margin mr-2" small/>
                    Loading status
                  </div>
                )
                : (
                  <div className="batch-provision-status">
                    <StatusBadge value={connStatusName} />
                    {updatedOn && <p className="batch-provision-last-update">Last update: {lastUpdateTime}</p>}
                  </div>
                )
            }
          </div>
        </div>
        <div className="row">
          <div className="ml-auto col-8">
            <div className="batch-provision-begin-button">
              {canLoadTrialBalanceAndCalculate ? (
                <Button
                  type="button"
                  kind="primary"
                  isLoading={isUploading}
                  className="a-my-10"
                  onClick={calculateProvisionsForGlUIConnection}
                  disabled={isUploading || !connection}
                >
                  Begin Process
                </Button>
              ) : null}
            </div>
          </div>

          <div className="ml-auto col-4">
            <div className="batch-provision-buttons">
              <Button
                type="button"
                kind="secondary"
                onClick={refreshStatus}
                disabled={!connection}
              >
                Refresh Status
              </Button>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default GlUIConnectionForm;
